<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
     <TableView
          :headers="headers"
          :items="allData"
          :options.sync="options"
          :loading="loading"
          :totalData="totalData"
          :refresh-table="getData"
          :bodyFilter="true"
          :customTopActions="true"
          item-key="id"
          table-height="70vh"
        >     
           <template v-slot:body-prepend>
            <StockMidListFilter :search="search" v-on:getDataParent="getData" />
          </template>
          <template v-slot:custom="{ item }">
            <div
          :class="{
            'red--text': item.stock_mid <= 50,
            'font-weight-black': true,
          }"
        >
          {{ item.stock_mid }}
        </div>
          </template>
      </TableView>
  </v-card>
</template>

<script>
import { date } from '../../lib/helpers';
import { headersList } from '../mid/stock-mid/attributes';

export default {
  components: {
    StockMidListFilter: () => import('../table/StockMidListFilter.vue'),
    TableView: () => import("../@drontVue/components/Table/TableView.vue"),
  },
  props: {
    tabContent: {
      type: String,
      default: null,
    },
  },
  name: 'StockMidList',
  data: () => ({
    isFirstLoad: false,
    options: {},
    view: false,
    dialog: false,
    headers: headersList,
    search: {
      areaCode: '',
      areaName: '',
      merchantType: '',
    },
    selectedRow: '',
  }),
  watch: {
    options: {
      handler() {
        if (!this.isFirstLoad) {
          this.getData();
        } else {
          this.$store.commit('stockMid/list/clearData');
        }
        this.isFirstLoad = false;
      },
      deep: true,
    },
    tabContent(val) {
      if (val === 'monitoring' && (this.updatedFill || this.updatedBulk)) {
        this.getData();
      }
    },
  },
  computed: {
    allData() {
      return this.$store.state.stockMid.list.allData;
    },
    totalData() {
      return this.$store.state.stockMid.list.totalData;
    },
    totalPage() {
      return this.$store.state.stockMid.list.totalPage;
    },
    loading() {
      return this.$store.state.stockMid.list.loading;
    },
    updatedFill() {
      return this.$store.state.stockMid.fill.updatedFill;
    },
    updatedBulk() {
      return this.$store.state.stockMid.bulk.updatedBulk;
    },
    flashError: {
      get() {
        return this.$store.state.stockMid.list.flashError;
      },
      set() {
        this.$store.commit('stockMid/list/setFlashErrorMessage', '');
      },
    },
    flashErrorMessage() {
      return this.$store.state.stockMid.list.flashErrorMessage;
    },
  },
  methods: {
    selectRow(index) {
      if (this.selectedRow !== index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },
    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },
    getData() {
      this.$store.commit('stockMid/list/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store
        .dispatch('stockMid/list/getData', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage === 0) {
              this.options.page = 1;
            } else {
              this.options.page = this.totalPage;
            }
          }
        })
        .finally(() => {
          this.$store.commit('stockMid/fill/setUpdatedFill', false);
          this.$store.commit('stockMid/bulk/setUpdatedBulk', false);
        });
    },
    clearSearch() {
      this.search.areaCode = '';
      this.search.areaName = '';
      this.search.merchantType = '';
      this.$nextTick(() => {
        this.$store.commit('stockMid/list/clearData');
        this.getData();
      });
    },
  },
};
</script>
